import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { account } from './account'
import { appupdate } from './appupdate'
import { artifacttypes } from './artifacttypes'
import { forgotpassword } from './forgotpassword'
import { frameworkskills } from './frameworkskills'
import { frameworksubjects } from './frameworksubjects'
import { gradelevels } from './gradelevels'
import { modal } from './modal'
import { mockcourses } from './mockcourses'
import { mycourses } from './mycourses'
import { myquests } from './myquests'
import { myquestsfilters } from './myquestsfilters'
import { navigation } from './navigation'
import { organization } from './organization'
import { organizations } from './organizations'
import { policies } from './policies'
import { productionstatus } from './productionstatus'
import { productionstatusfilters } from './productionstatusfilters'
import { quest } from './quest'
import { quests } from './quests'
import { questsfilters } from './questsfilters'
import { questtypes } from './questtypes'
import { queue } from './queue'
import { queuefilters } from './queuefilters'
import { resetpassword } from './resetpassword'
import { unlockaccount } from './unlockaccount'
import { reviewqueue } from './reviewqueue'
import { reviewqueuefilters } from './reviewqueuefilters'
import { subjects } from './subjects'
import { tags } from './tags'
import { topicclouds } from './topicclouds'
import { topics } from './topics'
import { user } from './user'
import { users } from './users'

const appReducer = combineReducers({
  account,
  appupdate,
  artifacttypes,
  forgotpassword,
  frameworkskills,
  frameworksubjects,
  gradelevels,
  mockcourses,
  modal,
  myquests,
  mycourses,
  myquestsfilters,
  navigation,
  organization,
  organizations,
  policies,
  productionstatus,
  productionstatusfilters,
  quest,
  quests,
  questsfilters,
  questtypes,
  queue,
  queuefilters,
  resetpassword,
  unlockaccount,
  reviewqueue,
  reviewqueuefilters,
  subjects,
  tags,
  topicclouds,
  topics,
  user,
  users,
  routing: routerReducer
})

export default (state, action) => {
  // super important, otherwise we got in weird states where
  // users see last logged-in users' stuff
  if (action.type === 'LOGOUT_USER') {
    state = undefined
  }

  return appReducer(state, action)
}



// WEBPACK FOOTER //
// ./src/reducers/index.js